import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Stores the screen keys granted to the currently authenticated user. */
@Injectable({ providedIn: 'root' })
export class UserModuleAccessService {
  private allowedModules = new Set<string>();
  private allowAllModules = false;
  private readonly allowedModulesSubject = new BehaviorSubject<readonly string[]>([]);
  readonly allowedModules$ = this.allowedModulesSubject.asObservable();

  setFromPermissionResponse(response: unknown, allowAllModules = false): void {
    const source = response as any;
    const candidates = [
      source?.own?.modules,
      source?.data?.own?.modules,
      source?.permissionConfig?.own?.modules,
      source?.data?.permissionConfig?.own?.modules,
      source?.entityPermissions?.permissionConfig?.own?.modules,
      source?.data?.entityPermissions?.permissionConfig?.own?.modules,
      source?.entityPermissions?.modules,
      source?.data?.entityPermissions?.modules,
      source?.entityPermissions?.entityPermissions?.modules,
      source?.data?.entityPermissions?.entityPermissions?.modules,
      source?.responseList?.[0]?.data?.[0]?.own?.modules,
    ];
    const modules = candidates.find((candidate) => Array.isArray(candidate)) || [];
    this.allowAllModules = allowAllModules;
    this.allowedModules = new Set(
      modules
        .map((moduleKey: unknown) => this.normalize(moduleKey))
        .filter(Boolean),
    );
    this.allowedModulesSubject.next(this.getAllowedModules());
  }

  clear(): void {
    this.allowAllModules = false;
    this.allowedModules.clear();
    this.allowedModulesSubject.next([]);
  }

  canAccess(moduleKey: unknown): boolean {
    const normalizedKey = this.normalize(moduleKey);
    return !!normalizedKey && (this.allowAllModules || this.allowedModules.has(normalizedKey));
  }

  getAllowedModules(): string[] {
    return this.allowAllModules ? ['*'] : [...this.allowedModules];
  }

  private normalize(value: unknown): string {
    return String(value || '').trim().toLowerCase();
  }
}
